module.exports = __webpack_public_path__ + "static/media/software-dot.f1d458c5.svg";